import "@babel/polyfill";
import "mutationobserver-shim";
import Vue from "vue";
import "./plugins/bootstrap-vue";
import "./plugins/font-awesome-icon";
import "./plugins/vue-cookies";
import "./plugins/vue-toastr";
import "./plugins/axios";
import "./plugins/vue-meta";
import "./plugins/firebase";
import "./directives/click-outside";
import "./directives/event-listener";
import "./directives/touch-event";
import App from "./App.vue";
import router from "./router";
import store from "./store";

Vue.config.productionTip = false;

new Vue({
   router,
   store,
   render: (h) => h(App)
}).$mount("#app");
